import { AppModals, useAppModal } from '@/context/ModalProvider'
import { useTranslation } from 'next-i18next/pages'
import { useGeoLocation } from '@/hooks/useGeoLocation'
import { Box, Button, ButtonProps, Icon, Tooltip } from '@chakra-ui/react'
import WalletIcon from '@/public/assets/icons/wallet.svg'
import Image from 'next/image'
import Img from '@/public/assets/images/home/deposit-bonus.png'
import { EnteringMode, useEnteringModeValue } from '@/hooks/useEnteringModeValue'

export const DepositButton = ({
  styles = {},
  text,
  mobile = true,
}: {
  styles?: ButtonProps
  text?: string
  mobile?: boolean
}) => {
  const { t } = useTranslation()
  const buttonText = text ?? t('common.deposit')
  const { restricted } = useGeoLocation()
  const modal = useAppModal()
  const { enteringMode } = useEnteringModeValue()

  const handleDepositModal = () => {
    modal.openModalNew(AppModals.DepositModal2)
  }

  if (restricted) {
    return (
      <Tooltip
        fontSize={'sm'}
        color={'ninja.100'}
        bg={'ninja.500'}
        rounded={'lg'}
        label={t('messages.region-restricted')}
        p={2}
      >
        <Box>
          <Button
            display={!mobile ? 'block' : { base: 'none', md: 'block' }}
            h={12}
            rounded={'2xl'}
            isDisabled={true}
            {...styles}
          >
            {buttonText}
          </Button>
          {mobile && (
            <Button
              onClick={handleDepositModal}
              display={{ base: 'none', sm: 'flex', md: 'none' }}
              rounded={'2xl'}
              boxSize={12}
              justifyContent={'center'}
              alignItems={'center'}
            >
              <Icon color={'white'} boxSize={5} as={WalletIcon} />
            </Button>
          )}
        </Box>
      </Tooltip>
    )
  }

  return (
    <Box pos={'relative'} height={12}>
      <Button
        display={!mobile ? 'block' : { base: 'none', md: 'block' }}
        h={12}
        rounded={'2xl'}
        onClick={handleDepositModal}
        {...styles}
      >
        {[EnteringMode.DepositBonus100, EnteringMode.Login].includes(enteringMode) && (
          <Box
            pos={'absolute'}
            zIndex={10}
            w={20}
            left={mobile ? -9 : 'auto'}
            bottom={mobile ? -9 : 'auto'}
            right={mobile ? 'auto' : -9}
            top={mobile ? 'auto' : -9}
          >
            <Image src={Img} alt="" />
          </Box>
        )}
        {buttonText}
      </Button>
      {mobile && (
        <Button
          onClick={handleDepositModal}
          display={{ base: 'none', sm: 'flex', md: 'none' }}
          rounded={'2xl'}
          boxSize={12}
          justifyContent={'center'}
          alignItems={'center'}
        >
          <Icon color={'white'} boxSize={5} as={WalletIcon} />
        </Button>
      )}
      {mobile && [EnteringMode.DepositBonus100, EnteringMode.Login].includes(enteringMode) && (
        <Box
          display={{ base: 'block', md: 'none' }}
          cursor={'pointer'}
          onClick={handleDepositModal}
          pos={'absolute'}
          right={'100%'}
          w={20}
          top={-4}
        >
          <Image src={Img} alt="" />
        </Box>
      )}
    </Box>
  )
}
